import React, { useState } from "react";
import ConfirmationModal from "../../../common/modal/confirmation-modal.jsx";
import RegisterForm from "../../../account/login/index.js";
import RegisterCompleteModal from "../../../common/modal/index.js";
import RegistrationButton from "./registrationButton.js";
import ProviderRegistration from "./providerRegistrationButton.js";
import { Col, Container, Row, Button } from "reactstrap";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import {
  registerForAuctions,
  validateTermsAcceptanceByEventId,
} from "../../../../reducers/events/index.js";
import {
  EventTypes,
  EventTypeStrings,
} from "../../../../constants/event-types.js";
import {
  EventStatus,
  EventStatusStrings,
} from "../../../../constants/event-status.js";
import { updateUserTermsAcceptance } from "../../../../reducers/auction/index.js";
import { updateTermsAcceptance, getContactInfo } from "../../../../reducers/account/index.js";
import AccountSelectionModal from "./accountSelectionModal.js";

const EventRegistration = (props) => {
  const {
    auction,
    callback,
    hasAccount,
    push,
    registerForAuctions,
    updateUserTermsAcceptance,
    updateTermsAcceptance,
    isGuest,
    refresh_token,
    passwordRequest,
    registerForEvent = null,
    validateTermsAcceptanceByEventId,
    isVIP,
    hasVerifiedPaymentMethod,
    onlineBiddingStatus_ID,
    isBlackFlagged,
    enableOnlineAuction,
  } = props;
  const [loginModalOpen, setLoginModal] = useState(false);
  const [termsAndConditionsDocument, setTermsAndConditionsDocument] = useState(
    ""
  );
  const [showTermsAcceptanceModal, toggleTermsAcceptanceModal] = useState(
    false
  );
  const [selectedEvent, setSelectedEvent] = useState();
  const [completeRegistrationModal, setCompleteRegistrationModal] = useState(
    false
  );
  const [showAccountSelectionModal, setShowAccountSelectionModal] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [pendingRegistrationCallback, setPendingRegistrationCallback] = useState(null);
  const [requiresTermsAcceptance, setRequiresTermsAcceptance] = useState(false);

  const accounts = props.contactInfo?.accounts ?? [];
  const hasMultipleAccounts = accounts.length > 1;

  // contactInfo is loaded by the parent page (auction/index.jsx or home page).
  // No need to re-fetch here — it comes through Redux props.

  const handViewAuctionItems = (event) => {
    let promise = new Promise((resolve, reject) => {
      resolve();
    });
    if (
      event.eventType_ID === EventTypes.Online &&
      event.eventStatus_ID === EventStatus.InProgress &&
      !enableOnlineAuction
    ) {
      promise.then(() => {
        push("/live-auction");
      });
    } else {
      promise.then(() => {
        push(`/search?page_number=1&events=${event.event_ID}`);
      });
    }
  };

  const handleNavigateToEvent = (id) => {
    let baseUrl = `${process.env.REACT_APP_SIMULCAST_BASE_URL}/auction/${id}`;

    if (isGuest) {
      window.open(baseUrl, "_blank");
    } else {
      window.open(baseUrl + `?token=${refresh_token}`, "_blank");
    }
  };

  const handleNavigateToOnlineAuction = (id) => {
    let baseUrl = `${process.env.REACT_APP_SIMULCAST_BASE_URL}/online-auction/${id}`;

    if (isGuest) {
      window.open(baseUrl, "_blank");
    } else {
      window.open(baseUrl + `?token=${refresh_token}`, "_blank");
    }
  };

  const handleRegisterForEvent = async (event, cb) => {
    setSelectedEvent(event);
    setPendingRegistrationCallback({ fn: cb });

    const params = {
      notificationsType: {
        txtNotification: true,
        emailNotification: true,
      },
      register: !event.isRegistered,
      event_ID: event.event_ID,
      ...event,
    };

    if ((!hasAccount || !hasVerifiedPaymentMethod) && !isVIP) {
      setCompleteRegistrationModal(true);
      return;
    }

    // Unregister path — no modal needed
    if (event.isRegistered && hasAccount) {
      await registerForAuctions({ ...params, account_ID: null }, cb);
      return;
    }

    // Register path
    if (!event.isRegistered && hasAccount) {
      // Pre-check terms & conditions before showing any modal
      const termsResult = await validateTermsAcceptanceByEventId({
        event_ID: event.event_ID,
      });
      const needsTerms = !termsResult.error && !termsResult.isCurrentTermsAcceptance;
      if (needsTerms) {
        setTermsAndConditionsDocument(termsResult.termsAndConditionsDocument);
      }
      setRequiresTermsAcceptance(needsTerms);

      if (hasMultipleAccounts) {
        const personalAccount = accounts.find((a) => a.isBusinessAccount === false);
        setSelectedAccountId(personalAccount ? personalAccount.account_ID : null);
        setShowAccountSelectionModal(true);
        return;
      }

      // Single account or no accounts — auto-select and register directly or show terms
      const autoAccountId = accounts.length === 1 ? accounts[0].account_ID : null;
      if (needsTerms) {
        setSelectedAccountId(autoAccountId);
        toggleTermsAcceptanceModal(true);
      } else {
        await registerForAuctions({ ...params, account_ID: autoAccountId }, cb);
      }
    }
  };

  const handleAccountSelectionConfirm = async () => {
    setShowAccountSelectionModal(false);

    const params = {
      notificationsType: {
        txtNotification: true,
        emailNotification: true,
      },
      register: !selectedEvent.isRegistered,
      event_ID: selectedEvent.event_ID,
      account_ID: selectedAccountId,
      ...selectedEvent,
    };

    await registerForAuctions(params, pendingRegistrationCallback?.fn);
  };

  const handleAcceptTermsInModal = async () => {
    setShowAccountSelectionModal(false);
    await updateUserTermsAcceptance(
      { event_ID: selectedEvent.event_ID },
      async (result) => {
        const params = {
          notificationsType: {
            txtNotification: true,
            emailNotification: true,
          },
          register: !selectedEvent.isRegistered,
          event_ID: selectedEvent.event_ID,
          account_ID: selectedAccountId,
          ...selectedEvent,
        };
        await registerForAuctions(params, pendingRegistrationCallback?.fn);
        updateTermsAcceptance(result);
      }
    );
  };

  const handleGoToMyAccount = () => {
    if (!hasAccount) {
      push("/register");
    } else {
      push("/myaccount");
    }
    setCompleteRegistrationModal(!completeRegistrationModal);
  };

  const handleTermsAcceptanceClick = async () => {
    await updateUserTermsAcceptance(
      { event_ID: selectedEvent.event_ID },
      (result) => {
        toggleTermsAcceptanceModal(false);
        registerForAuctions(
          {
            notificationsType: {
              txtNotification: true,
              emailNotification: true,
            },
            register: !selectedEvent.isRegistered,
            account_ID: selectedAccountId,
            ...selectedEvent,
          },
          callback
        );
        updateTermsAcceptance(result);
      }
    );
  };

  return (
    <React.Fragment>
      {auction.isThirdParty && (
        <React.Fragment>
          <ProviderRegistration
            providers={auction.providers}
            showCatalog={true}
          />
          {Array.isArray(auction.providers) && auction.providers.length === 0 && (
            <React.Fragment>
              <Button
                onClick={() => handViewAuctionItems(auction)}
                className="w-100 mb-2 btn btn-block"
              >
                <span>VIEW INVENTORY</span>
              </Button>
            </React.Fragment>
          )}
        </React.Fragment>
      )}
      {EventTypeStrings[auction.eventType_ID] === "Online" && (
        <div>
          {enableOnlineAuction ? (
            auction.eventStatus_ID === EventStatus.InProgress ? (
              <Button
                onClick={() => handleNavigateToOnlineAuction(auction.event_ID)}
                className="w-100 mb-2 btn btn-success border-success"
              >
                <span>JOIN LIVE AUCTION</span>
              </Button>
            ) : (
              <Button
                onClick={() => handleNavigateToOnlineAuction(auction.event_ID)}
                className="w-100 mb-2 btn btn-block"
              >
                <span>VIEW EVENT</span>
              </Button>
            )
          ) : (
            <RegistrationButton
              isRegistered={auction.isRegistered}
              onRegisterClick={() =>
                registerForEvent
                  ? registerForEvent(auction, callback)
                  : handleRegisterForEvent(auction, callback)
              }
              isGuest={isGuest}
              setLoginModal={setLoginModal}
              loginModalOpen={loginModalOpen}
              onlineBiddingStatus_ID={onlineBiddingStatus_ID}
              isBlackFlagged={isBlackFlagged}
            />
          )}
          <Button
            onClick={() => handViewAuctionItems(auction)}
            className={`w-100 mb-2 btn ${
              auction.eventStatus_ID === EventStatus.InProgress && !enableOnlineAuction
                ? "btn-success  border-success"
                : "btn-block"
            }`}
          >
            <span>
              {auction.eventType_ID === EventTypes.Online &&
              auction.eventStatus_ID === EventStatus.InProgress &&
              !enableOnlineAuction
                ? "JOIN LIVE AUCTION"
                : "VIEW INVENTORY"}
            </span>
          </Button>
        </div>
      )}
      {EventTypeStrings[auction.eventType_ID] === "Simulcast" && (
        <div>
          {auction?.providers
            ?.filter(
              (provider) =>
                provider.isCatalogURLLive || provider.isRegisterURLLive
            )
            .map((provider) => (
              <div key={provider.id} className={`w-100`}>
                <div
                  className="mb-2 btn btn-secondary w-100"
                  style={{
                    textAlign: "center",
                    background: "#555",
                    color: "#FFF",
                  }}
                >
                  {provider.name}
                </div>
                {provider.isRegisterURLLive && (
                  <Button
                    className="alert-secondary w-100 mb-2"
                    onClick={() =>
                      window.open(provider.providerRegisterURL, "_blank")
                    }
                  >
                    <i className="fa fa-calendar fa-lg boldLinkButton">
                      <span
                        style={{
                          fontFamily: "MyriadReg",
                          fontSize: "14px",
                          marginLeft: "15px",
                          textTransform: "uppercase",
                          verticalAlign: "middle",
                        }}
                      >
                        register
                      </span>
                    </i>
                  </Button>
                )}
              </div>
            ))}

          <Button
            onClick={() => handleNavigateToEvent(auction.event_ID)}
            className={`w-100 mb-2 btn ${
              auction.eventStatus_ID === EventStatus.InProgress
                ? "btn-success  border-success"
                : "btn-block"
            }`}
          >
            {auction.eventStatus_ID === EventStatus.InProgress ? (
              <span>JOIN LIVE AUCTION</span>
            ) : (
              <span>VIEW EVENT</span>
            )}
          </Button>
          <Button
            onClick={() => handViewAuctionItems(auction)}
            className="btn btn-secondary btn-block"
          >
            <span>VIEW INVENTORY</span>
          </Button>
        </div>
      )}
      {showTermsAcceptanceModal && (
        <ConfirmationModal
          showModal={showTermsAcceptanceModal}
          turnModal={toggleTermsAcceptanceModal}
          onSubmit={handleTermsAcceptanceClick}
          handleCancelSubmit={() =>
            toggleTermsAcceptanceModal((prevState) => !prevState)
          }
          header={"Accept Event's Terms and Conditions"}
          text={`The Terms and Conditions have changed. Please read the new version and accept to continue or you will not be able to register for the event.`}
          terms={termsAndConditionsDocument}
        />
      )}
      {loginModalOpen && (
        <RegisterForm
          {...{
            passwordRequest,
          }}
          isNavEvent={true}
          toggle={() => setLoginModal(!loginModalOpen)}
          isOpen={loginModalOpen}
        />
      )}
      {completeRegistrationModal && (
        <RegisterCompleteModal
          header={"Complete Registration"}
          children={
            <h3>To register for events please complete your registration</h3>
          }
          footer={
            <Button
              style={{ width: "100%" }}
              onClick={() => handleGoToMyAccount()}
              className="btn btn-blue"
            >
              Go to my account
            </Button>
          }
          toggle={() =>
            setCompleteRegistrationModal(!completeRegistrationModal)
          }
          isOpen={completeRegistrationModal}
        />
      )}
      <AccountSelectionModal
        isOpen={showAccountSelectionModal}
        toggle={() => setShowAccountSelectionModal(false)}
        accounts={accounts}
        selectedAccountID={selectedAccountId}
        onAccountSelect={setSelectedAccountId}
        onConfirm={handleAccountSelectionConfirm}
        onAcceptTerms={handleAcceptTermsInModal}
        loading={false}
        hasTerms={requiresTermsAcceptance}
        termsDocument={termsAndConditionsDocument}
      />
    </React.Fragment>
  );
};
const mapStateToProps = (state) => ({
  isGuest: state.authorization.isGuest,
  refresh_token: state.authorization.refresh_token,
  todaysEvents: state.events.todaysEvents,
  hasAccount: state.userAccount.hasAccount,
  onlineBiddingStatus_ID: state.userAccount.onlineBiddingStatus_ID,
  passwordRequest: state.register.passwordRequest,
  isVIP: state.userAccount.isVIP,
  hasVerifiedPaymentMethod: state.userAccount.hasVerifiedPaymentMethod,
  isBlackFlagged: state.userAccount.isBlackFlagged,
  contactInfo: state.userAccount.contactInfo,
  loadingContactInfo: state.userAccount.loadingContactInfo,
  enableOnlineAuction: state.featureFlags.enableOnlineAuction,
});

const mapDispatchToProps = {
  push,
  registerForAuctions,
  updateUserTermsAcceptance,
  updateTermsAcceptance,
  validateTermsAcceptanceByEventId,
  getContactInfo,
};
export default connect(mapStateToProps, mapDispatchToProps)(EventRegistration);
